import { render, staticRenderFns } from "./POSStorePackage.vue?vue&type=template&id=06c8d00c&scoped=true"
import script from "./POSStorePackage.vue?vue&type=script&lang=ts"
export * from "./POSStorePackage.vue?vue&type=script&lang=ts"
import style0 from "./POSStorePackage.vue?vue&type=style&index=0&id=06c8d00c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c8d00c",
  null
  
)

export default component.exports